<template>
  <div class="recordsNavigation">
    <el-progress
      v-if="currentRecord.progress"
      class="recordsNavigation__progress"
      :show-text="false"
      :percentage="currentRecord.progress"
    ></el-progress>
    <el-menu
      class="recordsNavigation__menu"
      :default-active="selected"
      @select="select"
    >
      <nav-records-resa :selected="selected === 'records-resa'" />
      <nav-records-tenant :selected="selected === 'records-tenant' || selected === 'records-tenant-update'" />
      <nav-records-guarant :selected="selected === 'records-guarant' || selected === 'records-guarant-update'" />
      <nav-records-justif
        :disabled="!isActive"
        :selected="selected === 'records-justif'"
      />
      <nav-records-messages
        :disabled="!isActive"
        :selected="selected === 'records-messages'"
      />
    </el-menu>
    <div class="recordsNavigation__details">
      <nav-records-tenant-details :selected="selected === 'records-tenant' || selected === 'records-tenant-update'" />
      <nav-records-guarant-details :selected="selected === 'records-guarant' || selected === 'records-guarant-update'" />
      <nav-records-justif-details
        :disabled="!isActive"
        :selected="selected === 'records-justif'"
      />
      <nav-records-messages-details
        :disabled="!isActive"
        :selected="selected === 'records-messages'"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import NavRecordsTenant from './navigation/NavRecordsTenant'
import NavRecordsGuarant from './navigation/NavRecordsGuarant'
import NavRecordsMessages from './navigation/NavRecordsMessages'
import NavRecordsJustif from './navigation/NavRecordsJustif'
import NavRecordsResa from './navigation/NavRecordsResa'
import NavRecordsTenantDetails from './navigation/NavRecordsTenantDetails'
import NavRecordsGuarantDetails from './navigation/NavRecordsGuarantDetails'
import NavRecordsMessagesDetails from './navigation/NavRecordsMessagesDetails'
import NavRecordsJustifDetails from './navigation/NavRecordsJustifDetails'

export default {
  name: "RecordsNavigation",
  components: {
    NavRecordsGuarant,
    NavRecordsJustif,
    NavRecordsMessages,
    NavRecordsResa,
    NavRecordsTenant,
    NavRecordsTenantDetails,
    NavRecordsGuarantDetails,
    NavRecordsMessagesDetails,
    NavRecordsJustifDetails
  },
  data: () => ({
    selected: null
  }),
  computed: {
    ...mapState({
      currentRecord: state => state.records.currentRecord,
      currentRecordTenants: state => state.recordsPeople.currentRecordTenants,
      currentRecordGuarantors: state => state.recordsPeople.currentRecordGuarantors
    }),
    isActive() {
      let hasTenants = false
      let hasGuarantor = false

      if (this.currentRecord && this.currentRecord.tenant_ids && this.currentRecord.tenant_ids.length > 0) {
        hasTenants = true
      }

      if ((this.currentRecord.guarantor_ids && this.currentRecord.guarantor_ids.length > 0) || (this.currentRecord.institutional_guarantor)) {
        hasGuarantor = true
      }

      if (hasGuarantor && hasTenants) {
        return true
      }

      return false
    }
  },
  watch: {
    '$route.name': {
      immediate: true,
      handler(newVal) {
        this.selected = newVal
      }
    }
  },
  methods: {
    select(index) {
      this.selected = index
      let routeName = index
      const params = {
        id: this.currentRecord ? this.currentRecord.id : 'new'
      }
      if (index === 'records-tenant' && this.currentRecord && this.currentRecord.tenant_ids && this.currentRecord.tenant_ids.length > 0) {
        routeName = 'records-tenant-update'
        params.tenant_id = this.currentRecord.tenant_ids[0]
      } else if (index === 'records-guarant' && ((this.currentRecord.guarantor_ids && this.currentRecord.guarantor_ids.length > 0) || this.currentRecord.institutional_guarantor)) {
        routeName = 'records-guarant-update'
        if (this.currentRecord.institutional_guarantor) {
          params.guarantor_id = 'garantie-locative'
        } else {
          params.guarantor_id = this.currentRecord.guarantor_ids[0]
        }
      }
      this.$router.push({
        name: routeName,
        params
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.recordsNavigation';

#{$c} {
  &__menu {
    border-radius: 16px;
    background-color: #f6f6f6;
    box-shadow: 0 2px 12px 0 rgba(213, 213, 213, 0.5);
    margin-bottom: 30px;

    & > div {
      display: inline-block;
      padding: 0 2%;
      width: 16%;

      @include respond-above(xs) {
        &:nth-child(1) {
          width: 16%;
        }
        &:nth-child(2) {
          width: 15%;
        }
        &:nth-child(3) {
          width: 12%;
        }
        &:nth-child(4) {
          width: 24%;
        }
        &:nth-child(5) {
          width: 13%;
        }
      }
    }

    @include respond-above(md) {
      margin-bottom: 30px;
    }
  }

  &__details {
    @include respond-below(md) {
      margin-bottom: 20px;
    }
  }
}
</style>